// Formatowanie treści w nowym layoucie (pl-PL).

const NBSP = ' '

// Daty z BE przychodzą jako "2026-09-14 08:12:00" (str(datetime)) — Safari
// nie parsuje spacji, więc normalizujemy do ISO. "None"/puste → null.
export function parseDate(value) {
  if (!value || value === 'None') return null
  if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : value
  const date = new Date(String(value).trim().replace(' ', 'T'))
  return Number.isNaN(date.getTime()) ? null : date
}

// 12847 → "12 847" (twarda spacja, grupowanie także dla 4 cyfr jak w designie)
export function formatNumber(value) {
  const rounded = Math.round(Number(value) || 0)
  const sign = rounded < 0 ? '-' : ''
  return sign + String(Math.abs(rounded)).replace(/\B(?=(\d{3})+(?!\d))/g, NBSP)
}

// Metry: w statystykach z grupowaniem ("1 950 m"), na plakietkach bez ("2499 m")
export function formatMeters(value, { group = true } = {}) {
  const number = group ? formatNumber(value) : String(Math.round(Number(value) || 0))
  return `${number}${NBSP}m`
}

const shortDate = new Intl.DateTimeFormat('pl-PL', { day: 'numeric', month: 'short', year: 'numeric' })
const longDate = new Intl.DateTimeFormat('pl-PL', { day: 'numeric', month: 'long', year: 'numeric' })

// "14 wrz 2026"
export function formatShortDate(value) {
  const date = parseDate(value)
  return date ? shortDate.format(date).replace(/\.$/, '') : ''
}

// "12 sierpnia 2026"
export function formatLongDate(value) {
  const date = parseDate(value)
  return date ? longDate.format(date) : ''
}

// plural(3, ['szczyt', 'szczyty', 'szczytów']) → "szczyty"
export function plural(count, [one, few, many]) {
  const n = Math.abs(Math.floor(Number(count) || 0))
  if (n === 1) return one
  const lastDigit = n % 10
  const lastTwo = n % 100
  if (lastDigit >= 2 && lastDigit <= 4 && (lastTwo < 12 || lastTwo > 14)) return few
  return many
}

export function countLabel(count, forms) {
  return `${formatNumber(count)}${NBSP}${plural(count, forms)}`
}

export const PEAK_FORMS = ['szczyt', 'szczyty', 'szczytów']

const ACTIVITY_LABELS = {
  Hike: 'Wędrówka',
  Walk: 'Spacer',
  Run: 'Bieg',
  TrailRun: 'Bieg w terenie',
  VirtualRun: 'Bieg',
  Ride: 'Rower',
  MountainBikeRide: 'Rower górski',
  GravelRide: 'Rower gravel',
  EBikeRide: 'Rower elektryczny',
  EMountainBikeRide: 'Rower górski (e-bike)',
  BackcountrySki: 'Skitury',
  NordicSki: 'Narty biegowe',
  AlpineSki: 'Narty zjazdowe',
  Snowboard: 'Snowboard',
  Snowshoe: 'Rakiety śnieżne',
  RockClimbing: 'Wspinaczka',
  IceClimbing: 'Wspinaczka lodowa'
}

export function activityTypeLabel(type) {
  if (!type) return 'Aktywność'
  return ACTIVITY_LABELS[type] || type
}

// Zastępstwo imienia (BE zwraca tylko e-mail): login z e-maila i inicjały.
export function userHandle(email) {
  const login = String(email || '').split('@')[0]
  return login ? `@${login}` : ''
}

export function userInitials(email) {
  const login = String(email || '').split('@')[0]
  const parts = login.split(/[._\-+\d]+/).filter(Boolean)
  const letters = parts.length >= 2 ? parts[0][0] + parts[1][0] : login.slice(0, 2)
  return letters.toUpperCase() || '?'
}
